import { render, staticRenderFns } from "./FoldersItem.vue?vue&type=template&id=c9353314&scoped=true&"
import script from "./FoldersItem.vue?vue&type=script&lang=js&"
export * from "./FoldersItem.vue?vue&type=script&lang=js&"
import style0 from "./FoldersItem.vue?vue&type=style&index=0&id=c9353314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9353314",
  null
  
)

export default component.exports